import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintWorkflow } from './';

/**
 * @component {kat-blueprint-workflow-overview} KatBlueprintWorkflowOverview Component used to place and filter components within the overview section.
 * @slot default Blueprint content for overview section.
 */
@register(KatBlueprintWorkflow.slotMapping.overview.name)
export class KatBlueprintWorkflowOverview extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintWorkflow.slotMapping.overview.name,
      KatBlueprintWorkflow.slotMapping.overview.allowed
    );
  }
}
